import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Breadcrumb.css';
import { IoIosArrowForward } from "react-icons/io";
import { FaCircle } from "react-icons/fa";

const Breadcrumb = ({ items }) => {
  return (
    <nav className="breadcrumb">
      <FaCircle className='icon-offset-dot' />
      {items.map((item, index) => (
        <span key={index}>
     

          {item.link ? (
            <Link to={item.link} state={item.state} className="breadcrumb-link">
              {item.label}
            </Link>
          ) : (
            <span className="breadcrumb-current">{item.label}</span>
          )}
          {index < items.length - 1 && <span className="breadcrumb-separator">   <IoIosArrowForward className='icon-offset' /></span>}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumb;
